module.exports = __webpack_public_path__ + "static/2020-fathers-day-post-771c4015165c75e9a416c1f2da729e23.jpg";